import { render, staticRenderFns } from "./SpaceWrapper.vue?vue&type=template&id=8c4b1d32"
import script from "./SpaceWrapper.vue?vue&type=script&lang=ts"
export * from "./SpaceWrapper.vue?vue&type=script&lang=ts"
import style0 from "./SpaceWrapper.vue?vue&type=style&index=0&id=8c4b1d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports